import { render } from "./PartnerContactForm.vue?vue&type=template&id=12c2086a"
import script from "./PartnerContactForm.vue?vue&type=script&lang=js"
export * from "./PartnerContactForm.vue?vue&type=script&lang=js"

import "./PartnerContactForm.vue?vue&type=style&index=0&id=12c2086a&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__